module.exports = __webpack_public_path__ + "img/julie.34cfdfc1.jpg";